import React from 'react';
import { Image } from '@spotify-internal/encore-web';

export const SpotifyConnectAvatarIcon = ({
  avatarUrl,
  displayName,
  size,
}: {
  avatarUrl?: string;
  displayName: string;
  size: number;
}) =>
  avatarUrl ? (
    <Image
      src={avatarUrl}
      alt={displayName}
      imageWidth={`${size}px`}
      imageHeight={`${size}px`}
      crop
      circle
    />
  ) : (
    <svg data-testid="badge" width={size} height={size} aria-hidden>
      <circle cx={size / 2} cy={size / 2} r={size / 2} fill="violet" />
      <text
        role="figure"
        x="50%"
        y="50%"
        dx="1"
        dy="4"
        fontSize={size / 3}
        fontWeight="bold"
        alignmentBaseline="middle"
        textAnchor="middle"
        fill="white"
      >
        {displayName.charAt(0).toUpperCase()}
      </text>
    </svg>
  );
